import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import foorgotBg from './forgotBg.png';



const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        height:'100vh',
        backgroundColor:'#536DFE',
        textAlign: 'center',

        backgroundImage: `url(${foorgotBg})`,
        backgroundRepeat: 'no-repeat',
        backgroundAttachment: 'fixed',
        backgroundPosition: 'left 7% bottom 120px',
        backgroundSize:'50%',
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },

}));

const InfoGraphics = () => {
    const classes = useStyles();
    return (
        <div className={classes.root}>

        </div>
    );
};

export default InfoGraphics;
